import React, { useState } from "react";
import axios from "axios"; // We'll continue to use axios for external APIs like ipify
import { Box, Stack, TextField, Button, Typography, CircularProgress } from "@mui/material";
import ApiClient from "../../api-client"

const ContactForm = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    try {
      // Fetch user's IP address from an external API
      const ipRes = await axios.get("https://api64.ipify.org?format=json");
      const ipAddress = ipRes.data.ip;

      // Send form data to your backend using your API client
      // Note: We assume no authentication token or dispatch is needed for this call.
      const res = await ApiClient.post('api/contact', { ...formData, ipAddress });

      if (res.success) {
        setResponseMessage("✅ Message sent successfully!");
        setFormData({ name: "", email: "", message: "" }); // Reset form fields
      } else {
        setResponseMessage("❌ Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("❌ Error sending message:", error);
      setResponseMessage("❌ Error sending message. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div id="contact">
      <Box
        sx={{
          maxWidth: "600px",
          margin: "60px auto",
          boxShadow: 3,
          borderRadius: 2,
          p: 4,
          backgroundColor: "#fff",
          textAlign: "center",
        }}
      >
        <Typography variant="h4" sx={{ mb: 3, fontWeight: "bold" }}>
          Contact Us
        </Typography>

        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              label="Your Name"
              variant="outlined"
              fullWidth
              required
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            <TextField
              label="Your Email"
              variant="outlined"
              type="email"
              fullWidth
              required
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            <TextField
              label="Your Message"
              variant="outlined"
              multiline
              rows={4}
              fullWidth
              required
              name="message"
              value={formData.message}
              onChange={handleChange}
            />

            <Button
              type="submit"
              variant="contained"
              style={{ backgroundColor: "#ea6d58" }}
              size="large"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Submit"}
            </Button>
          </Stack>
        </form>

        {responseMessage && (
          <Typography variant="body1" sx={{ mt: 3, color: responseMessage.includes("✅") ? "green" : "red" }}>
            {responseMessage}
          </Typography>
        )}
      </Box>
    </div>
  );
};

export default ContactForm;
